import { isEmpty, makeMap } from '@/utils/utils';
import { size, elType, valType, elOptionMap } from './dict';

/**
 * val为空返回defVal
 * @param {*} val 值
 * @param {*} defVal 默认值
 * @returns {val|defVal}
 */
export function validVal(val, defVal, rule = [null, undefined, '']) {
  return isEmpty(val, rule) ? defVal : val;
}

/**
 * 返回对应节点属性
 */
export function adaptorProps(elType, vm) {
  const list = elOptionMap[elType] || elOptionMap.default;
  return list.reduce((map, key) => {
    if (vm[key] && !isEmpty(vm[key])) {
      map[key] = vm[key];
    }
    return map;
  }, {});
}

/**
 * 校验值是否正确
 */
export const validator = {
  size: makeMap(size),
  elType: makeMap(elType),
  valType: makeMap(valType)
};

export function makeRules({ itemType, disabled, display, max, min, maxlLength, precision, $t }) {
  if (!display || disabled) return null;
  let validator = null;
  if (itemType === 'any') return null;

  if (itemType === 'int' || itemType === 'float' || itemType === 'double') {
    validator = function (_, value, callback) {
      if (!value || isNaN(value)) {
        callback(new Error($t('validNumber')));
      } else if (max > 0 && (value > max || value < min)) {
        callback(new Error($t('valueRange', { min, max })));
      } else if (`${value}`.indexOf('.') !== -1 && `${value}`.split('.')[1].length > precision) {
        if (precision === 0) {
          callback(new Error($t('enterInteger')));
        } else {
          callback(new Error($t('float', { precision })));
        }
      } else {
        callback();
      }
    };
  } else if (itemType === 'string') {
    validator = function (_, value, callback) {
      if (!value) {
        callback(new Error($t('enterParams')));
      } else if (value.length > validVal(maxlLength, 999, [0])) {
        callback(new Error($t('maxLength', { maxlLength })));
      } else {
        callback();
      }
    };
  } else {
    return null;
  }
  return validator;
}
